"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doAttack = doAttack;
const board_1 = require("@creature-chess/board");
const pathfinding_1 = require("../../../pathfinding");
const getTargetAttackPositions_1 = require("../../../targeting/utils/getTargetAttackPositions");
const getStats_1 = require("../../../utils/getStats");
const inAttackRange_1 = require("../../../utils/inAttackRange");
function doAttack(currentTurn, state, board, pieceRegistry, pieceId, { combatStore, creatures }) {
    const combat = combatStore.getPiece(pieceId);
    const otherCombat = combatStore.getPiece(state.payload.targetId);
    if (combat.canAttackAtTurn > currentTurn ||
        otherCombat.canBeAttackedAtTurn > currentTurn) {
        return [state];
    }
    const piece = pieceRegistry.getPieceById(pieceId);
    const piecePosition = board.getPiecePosition(pieceId);
    if (!piece || !piecePosition) {
        return [state];
    }
    const attackRange = (0, getStats_1.getAttackRange)(piece, creatures);
    const target = pieceRegistry.getPieceById(state.payload.targetId);
    const targetPosition = board.getPiecePosition(state.payload.targetId);
    const targetAlive = otherCombat.currentHealth > 0;
    // some issue with this target
    if (!target || !targetPosition || !targetAlive) {
        return [{ type: "wandering" }];
    }
    const inRange = (0, inAttackRange_1.inAttackRange)((0, board_1.packPosition)(piecePosition[0], piecePosition[1]), (0, board_1.packPosition)(targetPosition[0], targetPosition[1]), attackRange);
    if (inRange) {
        return [
            state,
            [{ type: "hit", payload: { targetId: state.payload.targetId } }],
        ];
    }
    // if we can't hit our target, is there a target immediately in range?
    const otherEnemyInRange = (0, getTargetAttackPositions_1.findEnemyInAttackRange)(board, pieceRegistry, piece.ownerId, (0, board_1.packPosition)(piecePosition[0], piecePosition[1]), attackRange);
    if (otherEnemyInRange) {
        return [
            { type: "attacking", payload: { targetId: otherEnemyInRange.piece.id } },
        ];
    }
    const pathfinder = new pathfinding_1.Pathfinder({
        width: board.width,
        height: board.height,
    });
    const nextPosition = (0, pathfinding_1.getNextPiecePosition)(pathfinder, (0, board_1.packPosition)(piecePosition[0], piecePosition[1]), combat.facingAway, attackRange, (0, board_1.packPosition)(targetPosition[0], targetPosition[1]), board);
    // can't move towards target, wait
    // TODO we should probably break here and find a new target
    if (!nextPosition) {
        return [state];
    }
    return [state, [{ type: "move", payload: nextPosition }]];
}
